<!-- Testimonial Start -->
<section class="section bg-light" id="projects">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="title text-center mb-5">
            <h3 class="font-weight-normal text-dark">Algunos <span class="text-warning">Proyectos</span></h3>
            <p class="text-muted">Te mostramos algunos de nuestros proyectos.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 testi-carousel">
          <owl-carousel-o [options]="testimonialOptions">
            <ng-template carouselSlide *ngFor="let item of data">
              <div class="item">
                <div class="testi-content m-3 position-relative text-center">
                    <img [src]="item.image" [alt]="item.name" style="height: 550px !important; width: 250px; margin-left: auto; margin-right: auto; object-fit: contain;">       
                  <div class="testi-user mt-4">
                    <div class="media align-items-center justify-content-center">
                      <div class="media-body text-center">
                        <h6 class="mb-1 text-dark f-15 font-weight-bold">{{item.name}}</h6>
                        <div style="min-height: 55px;">
                          <p class="text-muted mb-2 f-14">{{item.descrip}}</p>
                        </div>
                        <a *ngIf="item.name === 'Selector'" class="btn btn-warning text-white mt-2" [href]="item.link" target="_blank">Ver Aplicación</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>
      </div>
    </div>
  </section>
  <!-- Testimonial End -->
  
  